import { SelectC } from 'components'
import { useLoadOrderBusinessUnities } from 'modules/orders/hooks'

export const SelectUnities = () => {
  const { data, isLoading: businessUnitiesLoading } =
    useLoadOrderBusinessUnities({})

  const businessUnities = data?.data?.map((bu) => ({
    id: bu.id,
    name: bu.name.trim()
  }))

  return (
    <SelectC
      name="unities"
      label="Unidades de Negócio"
      options={businessUnities}
      getOptionLabel={(option: any) => option?.id + ' - ' + option?.name}
      loading={businessUnitiesLoading}
      isMultiple={true}
      disableCloseOnSelect
    />
  )
}
